import React, { useState } from 'react';
import './KG/Modal.css';
import './shared.css';

interface TypedConfirmModalProps {
  title: string;
  message: React.ReactNode;
  confirmWord: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const TypedConfirmModal: React.FC<TypedConfirmModalProps> = ({
  title,
  message,
  confirmWord,
  confirmLabel = 'Confirm',
  onConfirm,
  onCancel,
}) => {
  const [input, setInput] = useState('');

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onCancel}>&times;</button>
        </div>
        <div className="modal-body">
          <div style={{ marginBottom: '16px', color: 'var(--foreground)', fontSize: '14px' }}>
            {message}
          </div>
          <div className="form-group">
            <label style={{ fontSize: '13px', color: 'var(--muted-foreground)', display: 'block', marginBottom: '6px' }}>
              Type <code className="mono" style={{ background: 'var(--muted)', padding: '1px 5px', borderRadius: '3px', fontSize: '12px' }}>{confirmWord}</code> to confirm
            </label>
            <input
              type="text"
              className="form-control"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && input.trim() === confirmWord) onConfirm();
                if (e.key === 'Escape') onCancel();
              }}
              placeholder={confirmWord}
              autoFocus
            />
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="tab-btn tab-btn--ghost" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="tab-btn tab-btn--danger"
            disabled={input.trim() !== confirmWord}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TypedConfirmModal;
